
import Vue, { PropType } from 'vue'

import BtnReadmore from '~/components/common/btn-readmore.vue'
import Title from '~/components/specialist/section-title.vue'
import SwiperCounter from '~/mixins/swiper-counter'
import { WorkContent } from '~/models/'

export default Vue.extend({
  name: 'SpecialistProject',
  components: {
    Title,
    BtnReadmore
  },
  mixins: [SwiperCounter],
  props: {
    works: {
      type: Array as PropType<WorkContent[]>,
      default: () => [] as WorkContent[]
    }
  },
  computed: {
    totalSlides(): number {
      return this.works.length
    }
  }
})
